<script lang="ts" setup>
    import '../../css/choice.css';
    import { computed, reactive, onMounted } from 'vue'; 
    import { DropDownButtonIconType,ButtonDisplayStyle} from '../Enums/UiEnums';

    import DropDownButton from "../components/DropDownButton.vue";
    import DropDownButtonItem from "../components/DropDownButtonItem.vue"; 
    
    export type menuCallbackFunction = (httpResp: Response, errorMessage?: string) => void;
    export interface IDropDownMenu {
        enabled: boolean,
        menuBreak: boolean,
        label: string,
        dataValue: number,
        callBack?: menuCallbackFunction
    }
    
    const formData = reactive <
    {   
        menuHeader?: string,
        menuFooter?: string
    }>({    
        menuHeader: "",
        menuFooter: ""
    });
        
    const props =  withDefaults(defineProps<
    {
        dropDownMenu: IDropDownMenu[],
        menuHeader?: string,
        menuFooter?: string,
        otherIcon?: string,
        dropDownTitle? : string,
        disabled?: boolean
    }>(), {
        otherIcon: "",
        dropDownTitle: "",
        disabled: false
    });
    onMounted(async () => {  
        formData.menuHeader = props.menuHeader;
        formData.menuFooter = props.menuFooter;
    });  
    
    const displayDropDown = computed(() => props.otherIcon === "" ? true : false);
    const iconType = computed(() => (props.otherIcon === "" ? DropDownButtonIconType.DropDownOnly : DropDownButtonIconType.Other));
</script>
<style scoped>
.span-column {
  display: flex;
  flex-direction: column;
}

.long-line {
  border-top: 1px solid rgb(124, 122, 122);
}
</style>
<template>
    <DropDownButton 
        :buttonTitle="props.dropDownTitle"
        :display-style="ButtonDisplayStyle.Link" 
        :buttonIcon="iconType" 
        :showDownArrow="displayDropDown" 
        :otherIcon="props.otherIcon"
        :disabled="props.disabled">

        <div v-if="formData.menuHeader" class="ps-2 pe-2 pb-1 text-isalus-primary background-isalus-gray" style="font-size: .60rem; border-bottom: 1px solid silver;" >
            {{formData.menuHeader}}
        </div>

        <span v-for="(menuRecord,index) in props.dropDownMenu" :key="`claimMenu${menuRecord.dataValue}`">
            <div v-if="menuRecord.menuBreak"  class="span-column">
                <div class="long-line"></div>
            </div>
            <span v-if="!menuRecord.enabled" class="dropdown-item text-muted" disabled style="font-size: .70rem;">{{menuRecord.label}}</span>
            <DropDownButtonItem v-if="!menuRecord.menuBreak && menuRecord.enabled"
                style="font-size: .70rem;" 
                :data="menuRecord.dataValue" 
                @click="menuRecord.callBack">
                {{menuRecord.label}}
            </DropDownButtonItem>
        </span>

        <div v-if="formData.menuFooter" class="ps-2 pe-2 pt-1 text-isalus-primary background-isalus-gray" style="font-size: .60rem; border-top: 1px solid silver;" >
            {{ formData.menuFooter }}
        </div>
    </DropDownButton>
</template>